import { useEffect } from 'react';
import {
  CircleMarker,
  MapContainer,
  TileLayer,
  Tooltip,
  useMap,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

interface LocationMapProps {
  latitude: number;
  longitude: number;
  label: string;
  className?: string;
}

function LocationMapController({
  latitude,
  longitude,
}: Pick<LocationMapProps, 'latitude' | 'longitude'>) {
  const map = useMap();

  useEffect(() => {
    map.setView([latitude, longitude], map.getZoom());
  }, [latitude, longitude, map]);

  return null;
}

export function LocationMap({
  latitude,
  longitude,
  label,
  className = 'h-64',
}: LocationMapProps) {
  return (
    <div className={`overflow-hidden rounded-xl border border-gray-200 bg-gray-100 shadow-sm ${className}`}>
      <MapContainer
        className="h-full w-full"
        center={[latitude, longitude]}
        zoom={10}
        minZoom={3}
        scrollWheelZoom={false}
        preferCanvas={true}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
        <LocationMapController latitude={latitude} longitude={longitude} />
        <CircleMarker
          center={[latitude, longitude]}
          radius={8}
          pathOptions={{
            color: '#064e3b',
            fillColor: '#10b981',
            fillOpacity: 0.85,
            weight: 2,
          }}
        >
          <Tooltip direction="top" offset={[0, -6]} opacity={0.95}>
            <div className="text-xs font-semibold">{label}</div>
          </Tooltip>
        </CircleMarker>
      </MapContainer>
    </div>
  );
}
